export default __webpack_public_path__ + "static/violin-d6a8ca1d14fcae960a7108d3ac78b40d.jpeg";